import React from 'react';
import ReactDOM from 'react-dom';
import Privacy from './Privacy';

const el = document.querySelector('#privacy');
ReactDOM.render(
    <Privacy/>,
    el,
);
